const opacity = {
  lv3: 0.32,
  lv6: 0.6,
  lv8: 0.8,
  hard: 0.32,
  normal: 0.6,
  soft: 0.8
}

export default Object.freeze(opacity)
